import React from 'react';

const steps = [
  {
    number: 1,
    title: 'Discovery',
    description: 'We start by understanding your business goals, challenges, and requirements through in-depth consultations.'
  },
  {
    number: 2,
    title: 'Strategy',
    description: 'We create a tailored roadmap with clear milestones, timelines, and technology choices aligned to your needs.'
  },
  {
    number: 3,
    title: 'Implementation',
    description: 'Using agile methods, we build your solution with regular check-ins, demos, and adaptations based on your feedback.'
  },
  {
    number: 4,
    title: 'Optimization',
    description: 'We continuously monitor, measure, and refine your solution to ensure long-term success and maximum ROI.'
  }
];

const ApproachSection = () => {
  return (
    <section className="approach">
      <h2>Our Proven Approach</h2>
      <div className="approach-timeline">
        {steps.map(step => (
          <article key={step.number} className="step">
            <span className="step-number">{step.number}</span>
            <h3>{step.title}</h3>
            <p>{step.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default ApproachSection;
